import { createHashHistory } from 'history';

const customHistory = createHashHistory();

export default customHistory;
